<template>
  <div class="page">
    <!-- 配置历史列表 -->
    <div class="screenLine">
      <el-button type="warning" plain @click="handleBackClick">返回</el-button>
    </div>
    <div class="tableBox">

      <el-table :data="tableData" style="width: 100%" stripe>
        <el-table-column prop="beginTime" label="开始时间">
          
        </el-table-column>
        <el-table-column  label="完结时间">
          <template slot-scope="scope">
            {{ scope.row.endTime ? scope.row.endTime : '正在进行中' }}
          </template>
        </el-table-column>
        <el-table-column prop="createOperationInfo.userName" label="创建人">
        </el-table-column>
        <el-table-column prop="createOperationInfo.operationTime" label="添加时间">
        </el-table-column>

        <el-table-column  label="修改人">
          <template slot-scope="scope">
            {{ scope.row.updateOperationInfo ? scope.row.updateOperationInfo.userName : '--' }}
          </template>
        </el-table-column>
        <el-table-column  label="修改时间">
          <template slot-scope="scope">
            {{ scope.row.updateOperationInfo ? scope.row.updateOperationInfo.operationTime : '--' }}
          </template>
        </el-table-column>


      </el-table>

    </div>


  </div>
</template>

<script>
export default {

  data() {
    return {
      visible: true,

      tableData: [],


    };
  },
  created() { },
  mounted() {
    this.getTableData();
  },
  methods: {

    getTableData() {
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_zichan + "/api/Performance/GetStaffPerformanceConfigList")
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.tableData = res.data;
            console.log(res, 'totak');
          }
        });
    },
    // 返回
    handleBackClick() {
      this.$router.go(-1)
    }
  }
}
</script>

<style></style>